module.exports = __webpack_public_path__ + "img/department-line-green.8958093f.svg";